export default __webpack_public_path__ + "static/media/logo-us-6pm.d7b41389.svg";